import React from "react";
import { createEntryPage } from "../FullPageLayout/FullPageLayout";
import styled from "styled-components";
import FlexBox from "../../elements/v2/Box/FlexBox";
import { breakpoints } from "../../../utils/styledHelpers";

export type WebExtensionPageProps = {
  username: string;
};

const WebExtensionPage = ({ username }: WebExtensionPageProps) => {
  return (
    <Container>
      <p>
        Hello {username}!
        <br />
        Check Cookies for the <code>jwt_token</code>
      </p>
    </Container>
  );
};

const Container = styled(FlexBox)`
  justify-content: center;
  background: #fafafa;
  text-align: center;
  padding: 32px 32px 64px 32px;
  min-height: calc(100vh - 100px);
  ${breakpoints.down("sm")} {
    padding-left: 16px;
    padding-right: 16px;
  }
`;

type Args = {
  topbar: any;
  webExtensionPage: WebExtensionPageProps;
};

const mapEntryProps = ({ topbar, webExtensionPage }: Args) => ({
  pageProps: {
    topbarProps: topbar,
  },
  componentProps: webExtensionPage,
});

export default createEntryPage(mapEntryProps)(WebExtensionPage);
